module.exports = __webpack_public_path__ + "img/54.97e51415.jpg";